import { render, staticRenderFns } from "./MySubscriptionCard.vue?vue&type=template&id=3d4f23dc&scoped=true&"
import script from "./MySubscriptionCard.vue?vue&type=script&lang=ts&"
export * from "./MySubscriptionCard.vue?vue&type=script&lang=ts&"
import style0 from "./MySubscriptionCard.vue?vue&type=style&index=0&id=3d4f23dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f23dc",
  null
  
)

export default component.exports